import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './OracleHome.css'

const asset = (name) => `${process.env.PUBLIC_URL}/images/oracles/${name}`

const ORACLES = [
  { view: 'prelive', image: 'card_1.png' },
  { view: 'polymarket', image: 'card_2.png' },
  { view: 'quantumodds', image: 'card_3.png' },
]

const OracleHome = ({ onSubmit }) => {
  const { t, i18n } = useTranslation()
  const tr = (key) => t(`oracleHome.${key}`)
  const language = (i18n.resolvedLanguage || i18n.language || 'pt').split('-')[0]
  const imageName = { en: 'imagem_principal_ingles.png', es: 'imagem_principal_espanhol.png' }[language] || 'imagem_principal.png'
  const heroImage = asset(imageName)
  const examples = t('oracleHome.examples', { returnObjects: true })
  const features = t('oracleHome.quantumFeatures', { returnObjects: true })
  const [input, setInput] = useState('')
  const inputRef = useRef(null)

  const submit = (event) => {
    event.preventDefault()
    if (input.trim()) onSubmit(input.trim())
  }

  return (
    <main className="oracle-home" aria-label={tr('pageLabel')}>
      <div className="oracle-home-top">
        <section className="oracle-home-hero" aria-label={tr('heroLabel')} style={{ '--oracle-hero-image': `url("${heroImage}")` }}>
          <img
            src={heroImage}
            alt={tr('heroAlt')}
            width="2048"
            height="761"
            fetchPriority="high"
          />
        </section>
        <aside className="oracle-home-quantum" aria-label={tr('quantumLabel')}>
          <img src={asset('quantum_odds_logo.png')} alt="Quantum Odds" width="184" height="55" />
          <h1>{tr('quantumHeadline.0')}<br />{tr('quantumHeadline.1')}</h1>
          <ul>
            {features.map((feature) => <li key={feature}>{feature}</li>)}
          </ul>
          <a href="https://quantumodds.xyz/" target="_blank" rel="noopener noreferrer">{tr('quantumAction')} <span aria-hidden="true">→</span></a>
        </aside>
      </div>

      <section className="oracle-home-query" aria-label={tr('askLabel')}>
        <form onSubmit={submit}>
          <label className="visually-hidden" htmlFor="oracle-home-prompt">{tr('askLabel')}</label>
          <textarea
            id="oracle-home-prompt"
            ref={inputRef}
            value={input}
            onChange={(event) => setInput(event.target.value.slice(0, 2000))}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) submit(event)
            }}
            placeholder={tr('placeholder')}
            rows="1"
            maxLength="2000"
          />
          <button type="submit" disabled={!input.trim()} aria-label={tr('sendLabel')}>↑</button>
        </form>
        <div className="oracle-home-examples">
          <span>{tr('examplesLabel')}</span>
          {examples.map(([title, prompt]) => (
            <button type="button" key={title} onClick={() => { setInput(prompt); inputRef.current?.focus() }}>{title}</button>
          ))}
        </div>
      </section>

      <nav className="oracle-home-cards" aria-label={tr('cardsLabel')}>
        {ORACLES.map((oracle, index) => (
          <Link key={oracle.view} to={`/oracle?view=${oracle.view}`} className={`oracle-home-card is-${oracle.view}`}>
            <img src={asset(oracle.image)} alt="" width="640" height="360" />
            <span className="oracle-home-card-number">0{index + 1}</span>
            <div className="oracle-home-card-content">
              <span className="oracle-home-card-label">{tr(`cards.${oracle.view}.label`)}</span>
              <h2>{tr(`cards.${oracle.view}.title`)}</h2>
              <p>{tr(`cards.${oracle.view}.description`)}</p>
              <span className="oracle-home-card-action">{tr('cardAction')} <span aria-hidden="true">→</span></span>
            </div>
          </Link>
        ))}
      </nav>
    </main>
  )
}

export default OracleHome
